<template>
  <div>
    <ul v-if="list.length > 0">
      <template v-for="(item, i) in list" :key="i">
        <template v-if="type === 'hospital'">
          <HospitalCassette :detail="item" />
        </template>
        <template v-else>
          <LatterBlockCassette :detail="item" />
        </template>
        <div
          class="eventBlock"
          v-if="
            (i + 1) % 5 === 0 || (list.length < 15 && i + 1 === list.length)
          "
        >
          <EventBanner />
        </div>
      </template>
    </ul>
    <div v-if="list.length === 0">
      <Alert text="お探しの条件では病院が見つかりませんでした。" />
      <Button
        :handleClick="() => $store.dispatch('showSearchModal')"
        label="再検索"
        primary
      />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue'
import HospitalCassette from '@/components/block/HospitalCassette.vue'
import LatterBlockCassette from '@/components/block/LatterBlockCassette.vue'
import EventBanner from '@/components/block/EventBanner.vue'
import Alert from '@/components/elements/Alert.vue'
import Button from '@/components/elements/Button.vue'

export default defineComponent({
  components: {
    HospitalCassette,
    LatterBlockCassette,
    EventBanner,
    Alert,
    Button
  },

  props: {
    list: {
      type: Array,
      default: () => []
    },
    type: {
      type: String as PropType<'hospital' | 'latter'>,
      default: 'hospital'
    }
  }
})
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.eventBlock {
  margin: 24px 0;

  @include mixins.media() {
    margin: 36px 0;
  }
}
</style>
